import React, { useState } from 'react';
import DataGrid, {
  Column, Editing, Popup, Paging, Lookup, Form,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';
import { Item } from 'devextreme-react/form';
import UploadPopup from '../fileUpload/UploadPopup';
import { Row } from 'devextreme-react/responsive-box';
import { ColorBox } from 'devextreme-react';
const notesEditorOptions = { height: 100 };

function SubTasksGrid(props) {
  const [isUploadPopupVisible, setUploadPopupVisibility] = useState(false);
  const [selectedTask_id, setSelectedTask_id] = useState("");
  const [selectedTaskName, setSelectedTaskName] = useState("");

const filteredSubtasks = props.subtasks?.filter(subtask => {
  // Exclude if status is one of the unwanted statuses
  const excludedStatuses = ["בוצע", "סירוב לקוח", "בוצע עי לקוח"];
  const hasExcludedStatus = excludedStatuses.includes(subtask.status?.status);

  // Exclude if it has the specific tag
  const hasTag = subtask.tags?.some(tag => tag.name === "התקבלה תגובת מחתים");

  return !hasExcludedStatus && !hasTag;
});


  const handleCellClick = (e) => {
    setSelectedTask_id(e.id);
    setSelectedTaskName(e.name);
    setUploadPopupVisibility(true);
  };

  return (
    <div id="data-grid-demo" className={"content-block dx-card responsive-paddings signers"} style={{ padding: 0 }}>
      <DataGrid
        dataSource={filteredSubtasks}
        keyExpr="id"
        showBorders={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
      >
        <Row style={{ padding: 0 }} padding={0} height={5} />
        <Paging enabled={false} />

        <Column
          dataField="עריכה"
          allowSorting={false}
          cellRender={({ data }) => (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'right' }}>
              <i
                className="fas fa-pen"
                onClick={() => handleCellClick(data)}
                style={{
                  marginLeft: '8px',
                  marginRight: '8px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  cursor: 'pointer',
                }}
              ></i>
            </div>
          )}
        />
        <Column
          dataField="name"
          caption="השלמות"
          minWidth={10}
          allowSorting={false}
        />
        <Column
          dataField="status.status"
          caption="סטטוס"
          width={180}
          alignment="center"
          cellRender={({ data }) => (
            <div
              style={{
                backgroundColor: data.status?.color,
                padding: '8px',
                color: 'white',
                borderRadius: '5px',
                boxShadow: '0 1px 3px rgba(0,0,0,.24)',
              }}
            >
              {data.status.status}
            </div>
          )}
        />
        {/* <Column
          dataField="clientResponse"
          caption="תגובת מחתים"
          minWidth={10}
          calculateCellValue={(data) => {
            return data.tags?.some(tag => tag.name === "התקבלה תגובת מחתים") ? true : false;
          }}
        /> */}
        <Column dataField="id" visible={false} />
      </DataGrid>
      <UploadPopup
        task_id={selectedTask_id}
        taskName={selectedTaskName}
        isUploadPopupVisible={isUploadPopupVisible}
        setUploadPopupVisibility={setUploadPopupVisibility}
        REACT_APP_SERVER_URL={props.REACT_APP_SERVER_URL}
        refreshData={props.refreshData}
      />
    </div>
  );
}

export default SubTasksGrid;
